import AdminView from './components/AdminView'

// Sync route definition
export default {
  path: '/admin',
  component : AdminView,
}
